import React from 'react';
interface PageHeaderProps {
  eyebrow: string;
  title: string;
  description: string;
}
export function PageHeader({
  eyebrow,
  title,
  description
}: PageHeaderProps) {
  return <header className="mb-7 max-w-3xl" data-id="element-61" data-mp="3rem0zk4adgrx">
      <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-campaign" data-id="element-62" data-mp="3rdauhcjghux4">{eyebrow}</p>
      <h1 className="mt-2 font-display text-4xl leading-none tracking-tight text-chalk sm:text-5xl" data-id="element-63" data-mp="3mgkcgjo3cp92">{title}</h1>
      <p className="mt-3 text-sm leading-relaxed text-mute" data-id="element-64" data-mp="2yqgbyl6795ma">{description}</p>
    </header>;
}